/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsLauncherDailyBonus interface.
 */
export function instanceOfFxIdDomainSettingsLauncherDailyBonus(value) {
    return true;
}
export function FxIdDomainSettingsLauncherDailyBonusFromJSON(json) {
    return FxIdDomainSettingsLauncherDailyBonusFromJSONTyped(json, false);
}
export function FxIdDomainSettingsLauncherDailyBonusFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Sku': json['Sku'] == null ? undefined : json['Sku'],
    };
}
export function FxIdDomainSettingsLauncherDailyBonusToJSON(json) {
    return FxIdDomainSettingsLauncherDailyBonusToJSONTyped(json, false);
}
export function FxIdDomainSettingsLauncherDailyBonusToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Sku': value['Sku'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsLauncherDailyBonus.js.map